// extracted by mini-css-extract-plugin
module.exports = {"container":"_025a50318d--container--XSkZQ"};